export default {
  type: {
    lang: 'en',
  },
  header: {
    help: 'Help',
    alliance: 'Alliance',
    pricing: 'Pricing',
    downloadApp: 'Download APP',
  },
  mailForm: {
    address: '8F 804, 396, World Cup buk-ro, Mapo-gu, Seoul, Republic of Korea',
    phrase_01: 'We are waiting for the contact for your successful business.',
    phrase_02:
      'It will be delivered to the person in charge according to the contents of the partnership, and we will reply after reviewing it.',
    co_name: 'Company Name',
    poc: 'Point Of Contact',
    email: 'E-mail',
    detail: 'Details',
    send: 'Contact Us',
  },
  home: {
    qr: {
      title: 'Download Mobile App',
      caption: 'You can install the app by scanning the QR Code.',
    },
    macOS: {
      title: 'Download macOS',
      caption:
        'Mac OS will be available as a trial service for the time being. Service may not be available for all models (except M1 and M2). If you have any questions, please contact the our team.',
      button: 'Download Here',
    },
    banner: {
      mainTit: 'Are You Ready?',
      subTit: 'Experience the Metaverse in the Ready Play.',
      downloadApp: 'Download APP',
      downloadMobileApp: 'Android App',
      downloadPcApp: 'Windows App',
      downloadiOSApp: 'iOS App',
      downloadiOSAppUrl: 'https://apps.apple.com/app/id1604332618',
      downloadMacOSApp: 'MacOS App',
      downloadMacOSAppUrl: '',
      downloadGuide01: 'Coming Soon! ReadyPlay for Mac OS in July!',
      downloadGuide02: 'Avatar 2.0 Update on July 19!',
    },
    event: {
      ssu: 'Soongsil University',
      ssu_desc:
        'Soongsil University Metaverse Admission Counseling and Campus Tour',
      gwhs: 'Daegu Gyeongwon High School Online Festival',
      gwhs_desc: 'Daegu Gyeongwon High School Online Metaverse Festival',
      ccei: 'Incheon Center for Creative Economy & Innovation',
      ccei_desc:
        'Incheon Creative Economy Innovation Center Performance Sharing Meeting',
      arir: 'Arirang TV Metabus Media Center On Live.',
      arir_desc: 'Live broadcast at Dokdo Media Center on March 1st.',
      kmeb: 'K-Metaverse Expo Busan 2022',
      kmeb_desc:
        'Exhibitions/Conferences specialized in Metaverse/VR/XR held in virtual Busan',
      kmes: 'KME & KMF 2022',
      kmes_desc:
        'Exhibitions/conferences specialized in Metaverse/VR/XR held in virtual Seoul',
      posid:
        'Postal Savings & Insurance Development Institute Vision Statement Event',
      posid_desc:
        'Vision declaration ceremony between labor and management of POSID',
      dokdo: 'Flash Mob Event for Dokdo day',
      dokdo_desc:
        'Dokdo flash mob event to celebrate Dokdo day by The Korea International Broadcasting Foundation',
      jsar: 'Jeongseon Korean Traditional Song, Hanbok Experience Event',
      jsar_desc:
        'Jeongseon Arirang & Hanbok Experience event by The Korea International Broadcasting Foundation',
      ssu2: 'Soongsil University - Pre-college World',
      ssu2_desc:
        'SSU Virtual Campus Experience, Deliver the School history education and school life information through Quest solving',
      popup_ssu_tit: 'Soongsil University',
      popup_ssu_txt:
        'Soongsil University Metaverse Admission Counseling and Campus Tour',
      popup_gwhs_tit: 'Daegu Gyeongwon High School Online Festival',
      popup_gwhs_txt: 'Daegu Gyeongwon High School Online Metaverse Festival',
      popup_ccei_tit: 'Incheon Center for Creative Economy & Innovation',
      popup_ccei_txt:
        'Incheon Creative Economy Innovation Center Performance Sharing Meeting',
      popup_arir: 'Arirang TV Metabus Media Center On Live.',
      popup_arir_desc: 'Live broadcast at Dokdo Media Center on March 1st.',
      popup_kmeb_tit: 'K-Metaverse Expo Busan 2022',
      popup_kmeb_txt:
        'Exhibitions/Conferences specialized in Metaverse/VR/XR held in virtual Busan',
      popup_kmes_tit: 'KME & KMF 2022',
      popup_kmes_txt:
        'Exhibitions/conferences specialized in Metaverse/VR/XR held in virtual Seoul',
      popup_posid_tit:
        'Postal Savings & Insurance Development Institute Vision Statement Event',
      popup_posid_txt:
        'Vision declaration ceremony between labor and management of POSID',
      popup_dokdo_tit: 'Flash Mob Event for Dokdo day',
      popup_dokdo_txt:
        'Dokdo flash mob event to celebrate Dokdo day by The Korea International Broadcasting Foundation',
      popup_jsar_tit:
        'Jeongseon Korean Traditional Song, Hanbok Experience Event',
      popup_jsar_txt:
        'Jeongseon Arirang & Hanbok Experience event by The Korea International Broadcasting Foundation',
      popup_ssu2_tit: 'Soongsil University - Pre-college World',
      popup_ssu2_txt:
        'SSU Virtual Campus Experience, Deliver the School history education and school life information through Quest solving',
      date: 'Date',
      details: 'Details',
      link: 'News',
      link_txt: 'Site URL',
    },
    promo: {
      phrase: 'How to make the virtual life in the imagination the daily life!',
    },
    service: {
      mainTit: 'Why Ready Play?',
      subTit_01: 'Strengthening Communication between Participants',
      subTit_02: 'Real-time/Non-Real-time Simultaneous Supports',
      subTit_03: 'Auto-production of Selfie 3D avatar',
      subTit_04: 'Various 3D Virtual Space Templates',
      subTit_05: 'Total Solution for an Online Meeting',
      subTit_06: 'Provision of Recording Service',
      text_01:
        'This platform strengthens communication between each other through the functions, such as exchanges of business cards and bulletin boards, etc., as well as eye contact and body languages.',
      text_02:
        'This platform supports real-time communications more vividly with its real 3D audios and can verify the past contents via a bulletin board even after an event.',
      text_03:
        'This provides some feeling as if you face a real person since 3D avatars are automatically created via Selfie.',
      text_04:
        'This can make a space customized for each event theme by providing various kinds of 3D virtual space templates.',
      text_05:
        'It is possible to share the materials necessary for a presentation in real-time with various types, such as images, PDFs, videos and YouTube links, etc.',
      text_06:
        'Since the recording service is provided, if necessary, it is possible to use some kinds of sketch videos and session ones, etc., as additional contents.',
    },
    devices: {
      mainTit: 'Compatible Machines',
      pcDesc_01:
        'Anyone, including Institutions, Schools, and Businesses, can use it. You can have Real Time meetings using the functions of screen sharing, video chat and etc.',
      pcDesc_02: '',
      pcConfig_category_tit: 'Category',
      pcConfig_category_01: 'Operating System',
      pcConfig_category_02: 'Graphics',
      pcConfig_category_03: 'CPU',
      pcConfig_category_04: 'DirectX',
      pcConfig_category_05: 'Storage',
      pcConfig_category_06: 'HDD',
      pcMinConfig_tit: 'Minimum Configuration',
      pcRecConfig_tit: 'Recommended Configurations',
      pcMinConfig_desc_01: 'Windows 7 64bit (or newer)',
      pcMinConfig_desc_02: 'Geforce GT 740 AMD Radeon HD 7750',
      pcMinConfig_desc_03: 'intel Core i3-4340 AMD FX 4330',
      pcMinConfig_desc_04: 'DirectX 11 (or newer)',
      pcMinConfig_desc_05: '8G',
      pcMinConfig_desc_06: 'Need more that 20G of free storage',
      pcRecConfig_desc_01: 'Windows 7 64bit (or newer)',
      pcRecConfig_desc_02: 'Geforce GTX 1060 3G AMD Radeon RX 580 4G',
      pcRecConfig_desc_03: 'intel Core i5-6600 AMD Ryzen 5 1600',
      pcRecConfig_desc_04: 'DirectX 11 (or newer)',
      pcRecConfig_desc_05: '16G',
      pcRecConfig_desc_06: 'Need more that 20G of free storage',
      mobileConfig: 'Android 8.0 (or newer)',
      mobileDesc_01:
        'You can use Ready Play conveniently at any time and anywhere though your mobile.',
      mobileDesc_02:
        'You can experience Avatar making, data sharing, bulletin guestbook and various contents.',
      vrDesc_01:
        'You can feel as if you were in the corresponding place actually using the VR.',
      vrDesc_02:
        'You can make conversations with friends and enjoy the Metaverse in a virtual space. ',
    },
  },
  help: {
    banner: {
      toolTip: 'Click the button below to view the manual and guidance.',
      manual: 'User Manual',
      guidance: 'Guidance',
      manual_url:
        'https://www.evernote.com/shard/s542/sh/8c9fae86-5162-12a4-2eee-56c42279e386/RbArz2pdXqRW1W21vhBFAUbX-JD1kjFYeKjvqsn3LYoPsKMBN2NeZqkV5w0',
    },
    faq: {
      mainTit: 'FAQ',
      qn_01: 'What kinds of files can I share in the screen?',
      ans_01:
        'The renewed Ready Play supports images, PDF files, videos, Youtube videos and Youtube Live. However, please, be reminded that videos can only be shared when they are full HD resolution and uses H264 codec only.',
      qn_02: 'What type of SNS can I use when I subscribe as a member?',
      ans_02:
        'You can currently subscribe as the Facebook account. Subscription types will be broadened later on.',
      qn_03: 'Can I log in simultaneously on a multiple machine?',
      ans_03:
        'You are not allowed to log in duplicately in a different machine using the same account.',
      qn_04: 'Can I subscribe again after withdrawing the membership?',
      ans_04:
        'Yes. You can subscribe again after withdrawing the membership. However, keep in mind that all the previously stored information will all be erased in this case.',
      qn_05: 'Up to how many people can participate in the Metaverse?',
      ans_05:
        'The maximum participating number of people for the meeting(land) is 131 people(room leader included). However, the number of speakers who show to be Avatar are 30 people and the participants(listeners) are 100 people. In other words, the participants(Listeners) who do not have Avatar can only see and listen, but they can not be seen nor speak as Avatars.',
      qn_06:
        'Should I subscribe as a member to participate in the Metaverse meeting? ',
      ans_06:
        'Yes. You should be subscribed to use all of the Metaverse services.',
      qn_07: 'Can anybody make the Metaverse meeting?',
      ans_07:
        'Yes. Anyone can make and participate in the meeting freely at no cost.',
      qn_08:
        'If I subscribe again after withdrawing the membership, do I lose the current friends?',
      ans_08:
        'Yes. Since all the information is erased and thus the information about friends also disappears.',
      qn_09: 'What types of cellular phone can I use it on?',
      ans_09:
        'You can use it in the android smartphone 8.0 or over. iSO is under development.',
      qn_10: 'What is the Metaverse meeting?',
      ans_10:
        'It is a virtual space in the Metaverse world and various spaces such as conference halls, lobbies and classrooms are arranged. You can have conversations with the other party through the video chatting in the Metaverse meeting.',
      qn_11: 'With whom can I perform the voice chatting?',
      ans_11: 'You can do it with the Avatar in the social world.',
      qn_12: 'Can only those I invited enter the conference?',
      ans_12:
        'If you set the password, only those who know the password can log in. Anyone can participate in the disclosed Metaverse meeting room.',
      qn_13:
        'Can I see in a big picture the presentation data in the Mataverse meeting(land)?',
      ans_13:
        'Yes. You can magnify the showing screen to see the presentation data in a large picture.',
      qn_14: 'How can I call the presentation data?',
      ans_14:
        'Press on the + button in the upper right side of the screen and the window to call the data pops up.',
      qn_15: 'Can anyone turn the pages of presentation data?',
      ans_15:
        'No. Only those who are designated as the presenter can turn the pages of presentation data.',
      qn_16: 'I feel like the speed has been slowed down.',
      ans_16:
        'The speed may go down if you use it for the first time after the updating. Try restarting the App. If the same problem continues after that, please, contact the customer center.',
      qn_17: 'Where should I contact if I have questions or inquiries?',
      ans_17_f: 'Send an e-mail at',
      ans_17_s: 'help@readypaly.co.kr',
      qn_18:
        'The audience is noisy when I wish to start the meeting and I would like to make it quite. What should I do?',
      ans_18:
        'Click on the participant list on the upper left side and click on the mike all/off button in the bottom.',
      qn_19:
        'Noise is heard since a specific user put the microphone on by mistake during the progression of the meeting. Can I turn off the microphone of that specific user only?',
      ans_19:
        'You can eliminate the sound of a specific person by checking the person whose microphone is on in the participants list in the upper left side and clicking on the microphone. The corresponding user can turn on the microphone again him/herself. ',
      qn_20: 'I can not see well since the screen is small.',
      ans_20: 'You can see it in full screen by clicking on the screen.',
    },
  },
  alliance: {
    banner: {
      mainTit_01: 'We wait for your cherishable proposal ',
      mainTit_02: 'for successful business.',
      toolTip_01:
        'Experience Ready Play space and features in a Free Tour Space!',
      toolTip_02: 'Please feel free to contact us on how to use Ready Play.',
      tour: 'Try Demo',
      partership: 'Partnership',
    },
    space: {
      mainTit_01: 'Try making necessary space such as',
      mainTit_02: 'corporations, schools, offices and government.',
      subTxt_01: 'You can manufacture the virtual space which suits the events',
      subTxt_02: 'other than the provided virtual background templates.',
    },
    confer: {
      mainTit_01: 'Proceed a',
      mainTit_02: 'realistic event',
      mainTit_03: '',
      mainTit_04: 'in the virtual space.',
      subTxt_01:
        'You can proceed with the live and well-conveying video conference using the sharing functions of the real-time PC screens and faces of the speakers who make the presentations.',
      subTxt_02: '',
    },
    avatar: {
      mainTit_01: '',
      mainTit_02: '',
      mainTit_03: '',
      mainTit_04: 'You can produce the brand and products that you wish to',
      mainTit_05: 'make known into Avatar parts.',
      subTxt_01: 'You can maximize the branding effects',
      subTxt_02: 'using the customized 3D Avatar.',
    },
  },
  pricing: {
    banner: {
      subTit_01: 'Anytime, Anywhere! Ready play',
      subTit_02: 'Try using the space and function that fits the event.',
      toolTip:
        'If you want to know more about the details, please feel free to contact us!',
      contact: 'Contact Us',
    },
    plan: {
      mainTit: 'Plan',
      mainDesc_01: 'All plans are based on one event.',
      mainDesc_02: 'VAT is not included',
      standTit_01: 'Plan',
      standTit_02: 'Item',
      standTit_03: 'Detail of Function',
      standTit_04: 'In Providing',
      avatar: 'Avatar',
      vSpace: 'Virtual Space',
      function: 'Function',
      participants: 'Number of Participants',
      duration: 'Retention Period',
      report: 'Report',
      av_td_01: '3D Avatar (Basic Avatar / User Selfie Production)',
      vs_td_01: 'Provide basic virtual space template',
      vs_td_02:
        'Opening a virtual space (disclosure, non-disclosure, event setting, announcement) Registered)',
      vs_td_03: "Virtual space search (by title and user's preference)",
      vs_td_04: 'Board, Guest book',
      vs_td_05: 'Installation of promotional materials in a virtual space.',
      vs_td_06: 'Up to 3.',
      fc_td_01: 'Voice / Text Chat (+Emoticon)',
      fc_td_02: 'File Sharing',
      fc_td_03: 'Video Streaming',
      fc_td_04: 'Add friends (Follow,Following)',
      fc_td_05: 'Invite / Withdraw a friend from the virtual space',
      fc_td_06: 'Replay the previous program',
      fc_td_07: 'Video Chat',
      fc_td_08: 'Event Recording',
      fc_td_09: '1 person',
      fc_td_10: 'Excluding Editing.',
      pc_td_01: 'Accessible per individual virtual space',
      pc_td_02: '100 people',
      dr_td_01: 'Virtual space retention period',
      dr_td_02: '1 month',
      rp_td_01: 'Statistical Data',
      rp_td_02: 'Unique Visitor',
      cms_td_01: 'Administrator Page',
      optTit_01: 'Customizing',
      custom_td_01: 'New production of Play World',
      custom_td_02: 'New Avatar production',
      custom_td_03: 'Avatar parts are newly produced.',
      custom_td_04: 'Top and bottom,',
      custom_td_05: ' 1 Each, 2 Set',
      notice:
        'Option items incur additional costs depending on the scope of work.',
    },
  },
};
